<template>
  <div class="filter-city-container">
    <cube-scroll :data="filterCityData.hot_cities" @scroll="scrollHandler" :scroll-events="[ 'scroll' ]" ref="cityScroll">
      <template v-for="(item, index) in letterList">
        <div v-if="filterCityData[item] && filterCityData[item].length" class="filter-city-item flex-column" :key="index">
          <span class="letter-code">{{ item | letterFilter }}</span>
          <div class="cities-content">
            <template v-for="val in filterCityData[item]">
              <div class="flex-center city-item" @click="pickCity(val)" :key="val.city_id"
                   :class="{'city-item-active': val.city_id === cityId }">{{ val.city_name }}</div>
            </template>
          </div>
        </div>
      </template>
    </cube-scroll>
  </div>
</template>

<script>
  export default {
    name: 'filter-city',
    props: {
      cityData: {
        type: Object,
        default: () => {
          return {}
        }
      },
      // 外部引入组件用v-show控制显示隐藏，用于dom显示的时候重新计算scroll的滚动高度
      filterValue: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        letterList: [],
        filterCityData: {},
        cityId: null,
        scrollY: 0
      }
    },
    computed: {},
    watch: {
      cityData(val) {
        if (val) {
          this._initCityData()
        }
      },
      filterValue(val) {
        if (val) {
          this.$refs.cityScroll.refresh()
          this.$refs.cityScroll.scrollTo(0, this.scrollY)
        }
      }
    },
    components: {},
    methods: {
      // 滚动事件
      scrollHandler({ y }) {
        this.scrollY = y
      },
      // 选择城市
      pickCity(val) {
        this.cityId = val.city_id
        this.$emit('changeCityCode', val)
      },
      // 初始化城市数据
      _initCityData() {
        const data = JSON.parse(JSON.stringify(this.cityData))
        this.letterList = Object.keys(data)
        if (data.hot_cities[0].city_id) {
          data.hot_cities.unshift({
            city_name: '全国',
            city_id: null
          })
        }
        this.filterCityData = data
      }
    },
    filters: {
      letterFilter(val) {
        return val === 'hot_cities' ? '热门城市' : val
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  .filter-city-container {
    width: 100vw;
    padding: 16px 8px 0 16px;
    background-color: $color-light;
    height: 445px;
    .filter-city-item {
      .letter-code {
        margin-bottom: 12px;
        line-height: 20px;
        color: $color-dark-gray;
        font-weight: 500;
        margin-top: 8px;
      }
      .cities-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .city-item {
          width: 31%;
          margin-right: 8px;
          border-radius: 3px;
          background-color: #F9F9F9;
          height: 38px;
          color: #606060;
          font-weight: 500;
          margin-bottom: 8px;
          &-active {
            background-color: $color-light;
            color: $color-theme;
            border: 1px solid $color-theme;
          }
        }
      }
      &:last-child {
        margin-bottom: 20px;
      }
    }
  }
</style>